import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Coins = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 14C21 12.9 20.1 12 19 12C20.1 12 21 11.1 21 10C21 8.9 20.1 8 19 8H13C12.9 8 12.9 8 12.8 8C13.9 8.2 14.6 9.2 14.5 10.3C14.4 11.2 13.7 11.9 12.8 12C12.9 12 12.9 12 13 12C12.9 12 12.9 12 12.8 12C13.9 12.2 14.6 13.2 14.5 14.3C14.4 15.2 13.7 15.9 12.8 16C12.9 16 12.9 16 13 16C12.9 16 12.9 16 12.8 16C13.9 16.2 14.6 17.2 14.5 18.3C14.4 19.2 13.7 19.9 12.8 20C12.9 20 12.9 20 13 20H19C20.1 20 21 19.1 21 18C21 16.9 20.1 16 19 16C20.1 16 21 15.1 21 14ZM11 16C12.1 16 13 15.1 13 14C13 12.9 12.1 12 11 12C12.1 12 13 11.1 13 10C13 8.9 12.1 8 11 8C12.1 8 13 7.1 13 6C13 4.9 12.1 4 11 4H5C3.9 4 3 4.9 3 6C3 7.1 3.9 8 5 8C3.9 8 3 8.9 3 10C3 11.1 3.9 12 5 12C3.9 12 3 12.9 3 14C3 15.1 3.9 16 5 16C3.9 16 3 16.9 3 18C3 19.1 3.9 20 5 20H11C12.1 20 13 19.1 13 18C13 16.9 12.1 16 11 16Z"
      fill="currentColor"
    />
  </svg>
)

export default Coins
